import { BookingV3FormRef } from 'features/Booking/v3/types';
import React from 'react';

export const bookingV3Ref = React.createRef<BookingV3FormRef>();

const BookingV3Manager: BookingV3FormRef = {
  resetFields: () => bookingV3Ref.current?.resetFields(),
  setFieldValue(name, value) {
    bookingV3Ref.current?.setFieldValue(name, value);
  },
} as BookingV3FormRef;

export default BookingV3Manager;
